import React from 'react'
import ReactDOM from 'react-dom'

import client from './common'
import ProductMainContent from './components/productMainContent'

const rootEl = document.getElementById('react-product-main-content')
document.querySelector('.react-skeleton-loading').style.display = 'none'

rootEl && ReactDOM.render(<ProductMainContent client={client} />, rootEl)
